import { render, staticRenderFns } from "./OfferExpensesForm.vue?vue&type=template&id=3c4e525e&scoped=true&"
import script from "./OfferExpensesForm.vue?vue&type=script&lang=js&"
export * from "./OfferExpensesForm.vue?vue&type=script&lang=js&"
import style0 from "./OfferExpensesForm.vue?vue&type=style&index=0&id=3c4e525e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e525e",
  null
  
)

export default component.exports